import { __read } from "tslib";
import { useEffect, useState } from 'react';
import { useIsomorphicLayoutEffect } from '@use-platform/react/libs/isomorphic-layout-effect';
import { canUseDOM } from './useIframeMaxHeight';
export var usePlatform = function (options) {
    var _a = options.touchBreakpointWidth, touchBreakpointWidth = _a === void 0 ? 520 : _a, _b = options.platform, userPlatform = _b === void 0 ? 'auto' : _b;
    var _c = __read(useState(function () {
        if (userPlatform !== 'auto') {
            return userPlatform;
        }
        if (!canUseDOM)
            return undefined;
        var touchMediaQuery = window.matchMedia("(max-width: " + touchBreakpointWidth + "px)");
        return touchMediaQuery.matches ? 'touch' : 'desktop';
    }), 2), platform = _c[0], setPlatform = _c[1];
    useEffect(function () {
        if (userPlatform !== 'auto') {
            setPlatform(userPlatform);
        }
    }, [userPlatform]);
    useIsomorphicLayoutEffect(function () {
        if (!canUseDOM || (userPlatform && userPlatform !== 'auto'))
            return;
        var mediaQuery = window.matchMedia("(max-width: " + touchBreakpointWidth + "px)");
        function onChange(event) {
            if (event.matches) {
                setPlatform('touch');
            }
            else {
                setPlatform('desktop');
            }
        }
        onChange(mediaQuery);
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', onChange);
        }
        else {
            // IE fallback
            mediaQuery.addListener(onChange);
        }
        return function () {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', onChange);
            }
            else {
                // IE fallback
                mediaQuery.removeListener(onChange);
            }
        };
    }, [platform, setPlatform, touchBreakpointWidth]);
    return platform;
};
